//教育培训页面新增时跳转到新页面导致激活状态消失
export default {
    '/examination/addQuestion':'/examination/questionBankManagenment',
    '/examination/addPaper':'/examination/paperManagement',
    '/trainingManagement/trainingResourceAdd':'/trainingManagement/trainingResource',
    '/examination/course/addCourse':'/examination/course/courseManagement',
    '/trainingManagement/addTeacher':'/trainingManagement/teacherManagement',
    '/trainingManagement/safetyTrainingProgramSave':'/trainingManagement/safetyTrainingProgramList',
    '/trainingManagement/addLatoja':'/trainingManagement/latojaManagement'
}


// WEBPACK FOOTER //
// ./src/assets/js/activeRoute.js